import React from "react";
import { FaEye, FaBullseye, FaGem } from "react-icons/fa";

function VMC() {
    const cards = [
        {
            icon: <FaEye />,
            title: "Our Vision",
            copy: "To be a leading force in the IT industry, empowering businesses to succeed through cutting-edge technology, innovative solutions, and a commitment to excellence. We envision a future where our services drive digital transformation, helping companies achieve sustainable growth and a competitive edge in the evolving digital landscape.",
        },
        {
            icon: <FaBullseye />,
            title: "Our Mission",
            copy: "Our mission is to provide high-quality, customized IT services that simplify complex challenges and optimize business performance. By leveraging the latest in technology and a customer-focused approach, we aim to deliver solutions that enhance productivity, improve security, and enable our clients to thrive in a digital-first world. We are dedicated to being a trusted partner, empowering our clients through each stage of their digital journey.",
        },
        {
            icon: <FaGem />,
            title: "Our Core Values",
            copy: "We are driven by a commitment to innovation, always seeking creative ways to deliver cutting-edge solutions that meet our clients' needs. Customer focus is at the heart of our approach, building lasting partnerships based on trust and transparency. Integrity guides every action, ensuring we operate with honesty and accountability. Our dedication to excellence means we consistently provide high-quality, reliable services, and our pursuit of continuous improvement keeps us adaptable and responsive in a rapidly evolving tech landscape.",
        },
    ];

    return (
        <section className="ciits-section vmc-section" aria-labelledby="vmc-title">
            <div className="ciits-container">
                <div className="ciits-section-heading ciits-section-heading--center">
                    <span className="ciits-eyebrow">What drives us at CIITS</span>
                    <h2 id="vmc-title" className="ciits-title">
                        Vision, Mission <span className="gradient-text">&amp; Values</span>
                    </h2>
                </div>

                <div className="vmc-grid">
                    {cards.map((card) => (
                        <article className="vmc-card" key={card.title}>
                            <div className="vmc-icon" aria-hidden="true">{card.icon}</div>
                            <h3>{card.title}</h3>
                            <p>{card.copy}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default VMC;
